import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';
import { App } from './App';
import { Auth0ProviderWithNavigate } from '@/components/layout/Auth0ProviderWithNavigate';
import { initAnalytics } from '@/lib/analytics';
import { captureReferralFromUrl } from '@/lib/referral';
import './styles/index.css';

initAnalytics();

// Capture `?ref=<code>` BEFORE Auth0Provider mounts and BEFORE React Router
// touches the URL — Auth0's redirect dance reads window.location, and the
// router's initial navigation would otherwise strip the param before we can
// see it. The capture is idempotent and a no-op when no ref is present.
captureReferralFromUrl();

const rootNode = document.getElementById('root');
if (!rootNode) {
  throw new Error('Root element #root not found in index.html');
}

const root = createRoot(rootNode);

/**
 * BrowserRouter wraps Auth0Provider so the SDK's `onRedirectCallback`
 * has access to `useNavigate()`. Without this ordering, React Router's
 * initial redirects strip the `code`/`state` query params before Auth0
 * can exchange them for a token.
 */
root.render(
  <StrictMode>
    <BrowserRouter>
      <Auth0ProviderWithNavigate>
        <App />
        <Toaster richColors closeButton position="top-right" />
      </Auth0ProviderWithNavigate>
    </BrowserRouter>
  </StrictMode>,
);
